import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import get from 'lodash/get';
import { config } from '@uhg-abyss/web/tools/config';

// Based on DS_API toggle we are checking permission.
export const getAppPermissions = (permissions, appDSPermissions) => {
  if (!permissions) {
    return true;
  }
  return permissions
    .split(',')
    .some((permission) => get(appDSPermissions, permission));
};

// Checking feature toggle status
export const getStatus = (
  status = true,
  permission,
  noPrivilegeHide,
  appDSPermissions
) => {
  const hasPermission = getAppPermissions(permission, appDSPermissions);
  let show = status;
  if (typeof status === 'string') {
    show =
      status.split(',').some((toggle) => getFeature(toggle)) || status === '';
  }
  if (noPrivilegeHide && show) {
    show = hasPermission;
  }
  return { hasPermission, show };
};

// Exit link modal and content is shown based on params provided in dashboardcontent.json
export const getExitLinkParams = (exitLink, params) => {
  if (exitLink) {
    let exitLinkUrl = config(exitLink.to);

    if (exitLink.to === 'UHC_SSO_URL') {
      // Removes trailing slash if present after removing hash
      const BASE_URL = window.location.href
        .replace(/\/?#.*/, '')
        .replace(/\/$/, '');
      exitLinkUrl = `${BASE_URL}/#/sso`;
    }

    if (exitLink.paramKey) {
      exitLinkUrl = `${exitLinkUrl}/${params[exitLink.paramKey]}`;
    }

    return {
      ...exitLink,
      to: exitLinkUrl,
    };
  }
  return null;
};

// Function returns the application name
export const getAppLink = ({ name, internalName, isInternal }) => {
  const isInternalLink =
    typeof isInternal === 'string' ? getFeature(isInternal) : isInternal;
  if (internalName && isInternalLink) {
    return { appName: internalName, isInternalLink };
  }
  return { appName: name, isInternalLink };
};
